module.exports = __webpack_public_path__ + "img/news15_4.df92f8e6.jpg";